export default "__VITE_ASSET__378991de__"